import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={107.988}
      height={109.818}
      viewBox="0 0 107.988 109.818"
      {...props}
    >
      <g data-name="Filled outline" transform="translate(-16 -16.004)">
        <path
          data-name="Path 169"
          d="M111.176 116.671H30.642V43.455l40.267-18.3 40.267 18.3z"
          fill="#003586"
        />
        <path
          data-name="Path 170"
          d="M30.642 94.566v22.1h80.534V43.458l-13.1-5.953z"
          fill="#ffd200"
        />
        <path
          data-name="Path 171"
          d="M70.909 25.155l-40.267 18.3v3.661l40.267-18.3 40.267 18.3v-3.661z"
          fill="#3086cd"
        />
        <path
          data-name="Path 172"
          d="M111.176 72.743H72.742V23.325h-3.661v49.418H30.642v3.661h38.437v40.267h3.663V76.404h38.437z"
          fill="#62a9e6"
        />
        <path
          data-name="Path 173"
          d="M111.177 36.134l-40.267-18.3-40.267 18.3-10.982 5.494v7.321l10.982-5.491 40.267-18.3 40.267 18.3 10.984 5.491v-7.321z"
          fill="#f35244"
        />
        <path
          data-name="Path 174"
          d="M111.177 36.137l-7.469-3.4-5.629 4.763 13.1 5.953 10.982 5.491v-7.316z"
          fill="#ea4a3b"
        />
        <rect
          data-name="Rectangle 32"
          width={36.455}
          height={63.975}
          rx={18.227}
          transform="translate(17.841 59.964)"
          fill="#e0e0de"
        />
        <path
          data-name="Path 175"
          d="M17.83 67.252h36.606v49.418H17.83z"
          fill="#4d5e78"
        />
        <path
          data-name="Path 176"
          d="M21.481 123.652a5.439 5.439 0 001.841.34h25.624a5.491 5.491 0 005.491-5.491v-1.831H24.219z"
          fill="#d6d6d4"
        />
        <path
          data-name="Path 177"
          d="M48.946 59.931h-2.475L43.6 67.252h10.838v-1.83a5.491 5.491 0 00-5.492-5.491z"
          fill="#d6d6d4"
        />
        <path
          data-name="Path 178"
          d="M24.218 116.67h30.218V67.252H43.597z"
          fill="#44546c"
        />
        <path
          data-name="Path 179"
          d="M47.116 107.519H25.152V83.725l10.982-5.491 10.982 5.491z"
          fill="#348fd9"
        />
        <path
          data-name="Path 180"
          d="M47.115 96.534V83.725l-10.982-5.491v18.3z"
          fill="#ffb531"
        />
        <path
          data-name="Path 181"
          d="M36.133 96.537h10.982v10.982H36.133z"
          fill="#ffb531"
        />
        <path
          data-name="Path 182"
          d="M37.964 80.064h-3.66v14.642h-9.152v3.658h9.152v9.152h3.661v-9.152h9.152v-3.661h-9.153z"
          fill="#62a9e6"
        />
        <path
          data-name="Path 183"
          d="M36.134 78.234l-10.982 5.491v1.83h21.964v-1.83z"
          fill="#62a9e6"
        />
        <path
          data-name="Path 184"
          d="M61.467 93.992l-7.03-8.437v15.95l-5.528-6.318a4.46 4.46 0 00-6.685 5.9l7.99 8.962-.568.852a11.1 11.1 0 00.568 13.087h13.375V99.855a9.151 9.151 0 00-2.121-5.859z"
          fill="#fec9a3"
        />
        <path
          data-name="Path 185"
          d="M96.534 52.609a5.376 5.376 0 01-.558 2.393 13.2 13.2 0 00-.922 2.4 9.722 9.722 0 00-.35 2.533h-7.321v-.394a9.735 9.735 0 00-1.226-4.448 5.417 5.417 0 01-.519-3.455 5.545 5.545 0 013.539-4.194 5.173 5.173 0 01.879-.236 5.493 5.493 0 016.47 5.12c.006.091.008.187.008.281z"
          fill="#ffb531"
        />
        <path
          data-name="Path 186"
          d="M94.703 59.931v5.491a1.83 1.83 0 01-1.83 1.83h-3.661a1.83 1.83 0 01-1.83-1.83v-5.491z"
          fill="#e0e0de"
        />
        <path
          data-name="Path 187"
          d="M96.534 52.609a5.378 5.378 0 01-.558 2.393 13.2 13.2 0 00-.922 2.4 9.718 9.718 0 00-.35 2.533h-3.661a11.143 11.143 0 011.272-4.928 5.376 5.376 0 00.558-2.393 5.534 5.534 0 00-3.695-5.168 5.173 5.173 0 01.879-.236 5.493 5.493 0 016.47 5.12c.001.089.007.185.007.279z"
          fill="#ffa912"
        />
        <path
          data-name="Path 188"
          d="M94.703 59.931v5.491a1.83 1.83 0 01-1.83 1.83h-3.661a1.83 1.83 0 001.83-1.83v-5.491z"
          fill="#d6d6d4"
        />
        <path
          data-name="Path 189"
          d="M37.964 41.628h25.624V52.61H37.964z"
          fill="#e0e0de"
        />
        <path
          data-name="Path 190"
          d="M37.964 48.949h25.624v3.661H37.964z"
          fill="#d6d6d4"
        />
        <path
          data-name="Path 191"
          d="M43.455 47.119h14.642v3.661H43.455z"
          fill="#b0b0ae"
        />
        <path
          data-name="Path 192"
          d="M72.74 29.648v-3.661l-1.831-.832-1.83.832v3.661l1.83-.832z"
          fill="#45a7d1"
        />
        <path
          data-name="Path 193"
          d="M96.534 94.707a5.376 5.376 0 01-.558 2.393 13.2 13.2 0 00-.922 2.4 9.72 9.72 0 00-.35 2.533h-7.321v-.394a9.736 9.736 0 00-1.226-4.448 5.417 5.417 0 01-.519-3.455 5.545 5.545 0 013.539-4.194 5.178 5.178 0 01.879-.236 5.493 5.493 0 016.47 5.12c0 .094.007.19.007.284z"
          fill="#ffb531"
        />
        <path
          data-name="Path 194"
          d="M94.703 102.028v5.491a1.83 1.83 0 01-1.83 1.83h-3.661a1.83 1.83 0 01-1.83-1.83v-5.491z"
          fill="#e0e0de"
        />
        <path
          data-name="Path 195"
          d="M96.534 94.707a5.378 5.378 0 01-.558 2.393 13.2 13.2 0 00-.922 2.4 9.718 9.718 0 00-.35 2.533h-3.661a11.146 11.146 0 011.272-4.928 5.376 5.376 0 00.558-2.393 5.534 5.534 0 00-3.695-5.168 5.177 5.177 0 01.879-.236 5.493 5.493 0 016.47 5.12c.001.089.007.185.007.279z"
          fill="#ffa912"
        />
        <path
          data-name="Path 196"
          d="M94.703 102.028v5.491a1.83 1.83 0 01-1.83 1.83h-3.661a1.83 1.83 0 001.83-1.83v-5.491z"
          fill="#d6d6d4"
        />
        <path
          data-name="Path 197"
          d="M122.976 39.99L71.667 16.168a1.837 1.837 0 00-1.516 0L18.842 39.99a1.83 1.83 0 00-1.012 1.638v7.321a1.83 1.83 0 002.649 1.637l8.333-4.168v8.022h3.661v-9.8l3.657-1.668v9.638a1.83 1.83 0 001.83 1.83h25.628a1.83 1.83 0 001.83-1.83V41.628a1.83 1.83 0 00-1.83-1.83H43.119L69.079 28v44.743H59.93V76.4h9.152v40.27a1.83 1.83 0 001.83 1.83h40.267a1.83 1.83 0 001.83-1.83V46.42l8.333 4.166a1.83 1.83 0 002.649-1.637v-7.321a1.83 1.83 0 00-1.012-1.637zM61.758 50.779h-3.661v-3.66H43.454v3.661h-3.66v-7.322h21.964zM72.739 28l36.606 16.638v28.105H72.739zm0 86.843V76.4h36.606v38.44zm47.591-68.856l-48.661-22.5a1.828 1.828 0 00-1.516 0l-48.661 22.5v-3.228l49.417-22.915 49.421 22.915z"
        />
        <path
          data-name="Path 198"
          d="M56.267 84.893V65.421a7.329 7.329 0 00-7.321-7.321H23.321A7.329 7.329 0 0016 65.421V118.5a7.329 7.329 0 007.321 7.321h40.267a1.83 1.83 0 001.83-1.83V99.849a10.991 10.991 0 00-2.547-7.026zM34.3 105.688h-7.318v-7.321H34.3zm10.982-21.964h-18.3v-.7l9.152-4.576 9.152 4.576zM34.3 94.706h-7.318v-7.321H34.3zm3.661 3.661h1.323a6.3 6.3 0 001.576 3.947l3.01 3.375h-5.91zm2.558-4.018c-.086.114-.153.238-.23.357h-2.325v-7.321h7.321v4.466a6.229 6.229 0 00-4.763 2.498zm8.424-12.455a1.83 1.83 0 00-1.012-1.637l-10.982-5.491a1.832 1.832 0 00-1.637 0L24.33 80.257a1.83 1.83 0 00-1.012 1.637v25.624a1.83 1.83 0 001.83 1.83h21.987l.774.867a12.828 12.828 0 00-1.764 4.628H19.661V69.082h32.945v27.544l-2.34-2.672a6.53 6.53 0 00-1.321-1.108zM23.321 61.761h25.625a3.665 3.665 0 013.661 3.661H19.661a3.665 3.665 0 013.66-3.661zm-3.66 56.739h26.4a12.844 12.844 0 00.992 3.661H23.321a3.665 3.665 0 01-3.661-3.661zm42.1 3.661H51.144a9.245 9.245 0 01-1.521-5.441 9.108 9.108 0 011.544-4.806l.568-.86a1.83 1.83 0 00-.159-2.227l-7.983-8.951a2.686 2.686 0 01-.67-1.764 2.468 2.468 0 01.173-.922 2.708 2.708 0 01.354-.647 2.617 2.617 0 013.058-.86 2.554 2.554 0 011.022.7l9.187 10.506 2.756-2.41-3.208-3.673v-10.2l3.793 4.553a7.334 7.334 0 011.7 4.683z"
        />
        <path
          data-name="Path 199"
          d="M98.364 52.609a7.322 7.322 0 00-14.53-1.291 7.247 7.247 0 00.7 4.613 7.872 7.872 0 011.022 3.6v5.886a3.666 3.666 0 003.661 3.661h3.661a3.665 3.665 0 003.661-3.661v-5.491a9.243 9.243 0 011.081-4.116 7.168 7.168 0 00.744-3.201zm-10.923-.661a3.711 3.711 0 012.929-2.94 3.666 3.666 0 014.334 3.6 3.541 3.541 0 01-.37 1.582 14.1 14.1 0 00-1.3 3.909h-3.927a12.516 12.516 0 00-1.321-3.85 3.611 3.611 0 01-.345-2.301zm1.771 13.474v-3.661h3.662v3.661z"
        />
        <path data-name="Path 200" d="M89.212 37.967h3.661v3.661h-3.661z" />
        <path data-name="Path 201" d="M76.4 50.779h3.661v3.661H76.4z" />
        <path data-name="Path 202" d="M102.025 50.779h3.661v3.661h-3.661z" />
        <path
          data-name="Path 203"
          d="M79.384 43.555l2.59-2.59 2.588 2.588-2.59 2.59z"
        />
        <path
          data-name="Path 204"
          d="M97.499 61.674l2.59-2.59 2.588 2.588-2.59 2.59z"
        />
        <path
          data-name="Path 205"
          d="M79.382 61.67l2.588-2.588 2.59 2.59-2.588 2.588z"
        />
        <path
          data-name="Path 206"
          d="M97.501 43.555l2.588-2.588 2.59 2.59-2.588 2.588z"
        />
        <path
          data-name="Path 207"
          d="M98.364 94.706a7.322 7.322 0 00-14.53-1.291 7.247 7.247 0 00.7 4.613 7.869 7.869 0 011.022 3.6v5.886a3.665 3.665 0 003.661 3.661h3.661a3.665 3.665 0 003.661-3.661v-5.491a9.243 9.243 0 011.081-4.116 7.168 7.168 0 00.744-3.201zm-10.923-.661a3.711 3.711 0 012.929-2.94 3.666 3.666 0 014.334 3.6 3.541 3.541 0 01-.37 1.582 14.1 14.1 0 00-1.3 3.909h-3.927a12.516 12.516 0 00-1.321-3.85 3.611 3.611 0 01-.345-2.301zm1.771 13.474v-3.661h3.662v3.661z"
        />
        <path data-name="Path 208" d="M89.212 80.064h3.661v3.661h-3.661z" />
        <path data-name="Path 209" d="M76.4 92.876h3.661v3.661H76.4z" />
        <path data-name="Path 210" d="M102.025 92.876h3.661v3.661h-3.661z" />
        <path
          data-name="Path 211"
          d="M79.379 85.648l2.59-2.59 2.588 2.588-2.59 2.59z"
        />
        <path
          data-name="Path 212"
          d="M97.495 103.767l2.59-2.59 2.588 2.588-2.59 2.59z"
        />
        <path
          data-name="Path 213"
          d="M79.377 103.763l2.588-2.588 2.59 2.59-2.588 2.588z"
        />
        <path
          data-name="Path 214"
          d="M97.496 85.648l2.588-2.588 2.59 2.59-2.588 2.588z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
